import React, { ReactNode, useContext } from 'react';
import { Modal, StyleSheet, TouchableHighlight, View } from 'react-native';

import { SvgXml } from 'react-native-svg';
import { defaultIconPack, IconPack } from '../lib/icons';
import { defaultConfig } from '../lib/default-ui-config';
import { DyteI18n, useLanguage } from '../lib/lang';
import { UIConfig } from '../types/ui-config';
import DyteClient from '@dytesdk/web-core';
import { States } from '../types/props';

import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  // ToDo: Figure out if we need this
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  config = defaultConfig,
  children,
  hideCloseButton = false,
  // ToDo: Figure out if we need this
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  meeting,
  open,
  onDyteDialogClose,
  states,
  // ToDo: Figure out if we need this
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  size,
  iconPack = defaultIconPack,
  t,
}: {
  config?: UIConfig;
  children: ReactNode;
  hideCloseButton?: boolean;
  meeting: DyteClient;
  open?: boolean;
  onDyteDialogClose: any;
  size?: 'lg' | 'md' | 'sm' | 'xl';
  states?: States;
  iconPack?: IconPack;
  t?: DyteI18n;
}) {
  const defaultLang = useLanguage();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  t = t ?? defaultLang;
  iconPack = iconPack ?? defaultIconPack;
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  states = states ?? storeStates;
  const styles = StyleSheet.create({
    container: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(0,0,0,0.4)',
    },
    popUp: {
      backgroundColor: colors.background[900],
      minHeight: '15%',
      minWidth: '80%',
      borderRadius: 10,
    },
    iconStyle: {
      position: 'absolute',
      opacity: hideCloseButton ? 0 : 1,
      top: 5,
      right: 5,
      padding: 5,
      zIndex: 9999,
    },
  });
  return (
    <Modal
      transparent
      visible={open}
      onRequestClose={() => {
        if (!hideCloseButton) onDyteDialogClose();
      }}
    >
      <View style={styles.container}>
        <View style={styles.popUp}>
          <TouchableHighlight
            underlayColor={colors.background[800]}
            style={styles.iconStyle}
            onPress={() => {
              if (!hideCloseButton) onDyteDialogClose();
            }}
          >
            <SvgXml
              xml={iconPack.dismiss.replace('currentColor', colors.text)}
              width={15}
              height={15}
            />
          </TouchableHighlight>
          <View>{children}</View>
        </View>
      </View>
    </Modal>
  );
}
